import axios from "@/api/axios";

const ukd_goods = (data) => {
  return axios.post("/api/ukds", data);
};

export default {
  ukd_goods,
};
